import { BondProductTypeEnum } from 'global/Securities/types/api/bond';

import { useBondsModalStore } from '../../stores/useBondsModalStore';
import { useBondPortfolioStore } from '../../stores/useBondPortfolioStore';
import { ModalBody, ModalContainer, ModalHeader } from '../../styled';

import ModalTitle from '../ModalTitle';

import ProductListItem from './components/ProductListItem';
import { ProductListContainer, ScrollableContainer } from './styled';

export default function ModalProductSelection() {
  const closeModal = useBondsModalStore((s) => s.closeModal);
  const transactions = useBondPortfolioStore((s) => s.transactions);
  const product = useBondPortfolioStore((s) => s.product);
  const clearAssets = useBondPortfolioStore((s) => s.clearAssets);

  const onClose = () => {
    clearAssets();
    closeModal();
  };

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle
          title="Pilih Produk untuk Dijual"
          fontSize="18px"
          onClose={onClose}
          isCentered
        />
      </ModalHeader>
      <ModalBody>
        <ScrollableContainer>
          <ProductListContainer>
            {transactions.map((transaction) => (
              <ProductListItem
                investmentModal={transaction.invested_amount}
                orderDate={new Date(transaction.created_at)}
                orderId={transaction.order_code}
                product={{
                  icon_url: product?.icon_url,
                  id: product?.identifier,
                  min_order: '1',
                  name: product?.label,
                  type: BondProductTypeEnum.FR,
                }}
                totalUnits={parseInt(transaction.total_unit, 10)}
                isStableEarn={transaction?.is_stable_earn}
                key={transaction.order_code}
              />
            ))}
          </ProductListContainer>
        </ScrollableContainer>
      </ModalBody>
    </ModalContainer>
  );
}
